<template>
  <Card class="basic-card w-100 min-h-auto">
    <div class="mdl-card__section basic-card-header">
      <div class="mdl-typography--body-1 typography--font-weight-600 typography--color-primary">
        {{ headerTitle }}
      </div>
    </div>

    <div class="mdl-card__section basic-card-body">
      <slot></slot>
    </div>

    <div class="mdl-card__section basic-card-footer">
      <slot name="footer"></slot>
    </div>
  </Card>
</template>

<script>
  export default {
    name: 'basic-card',

    props: {
      headerTitle: {
        type: String,
        default: 'title',
      },
    },
  };
</script>

<style lang="scss">
  .basic-card {
    border-radius: 4px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 8px;

    .basic-card-header {
      padding: 6px 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    }
  }
</style>



// WEBPACK FOOTER //
// BasicCard.vue?d8b69d62